// src/utils/dateUtils.js

/**
 * Ajusta una fecha para evitar problemas de zona horaria
 * @param {string|Date} date - Fecha a ajustar
 * @returns {Date} - Fecha ajustada
 */
export const adjustDateForTimezone = (date) => {
	if (!date) return null;

	// Si es un string, conviértelo a Date
	const dateObj = typeof date === 'string' ? new Date(date) : date;

	// Si no es una fecha válida, devuelve null
	if (isNaN(dateObj.getTime())) return null;

	// Ajusta la fecha sumando la diferencia de la zona horaria
	const timezoneOffset = dateObj.getTimezoneOffset() * 60000;
	return new Date(dateObj.getTime() + timezoneOffset);
};

/**
 * Formatea una fecha al formato dd/MM/yyyy
 * @param {Date} date - Fecha a formatear
 * @returns {string} - Fecha formateada
 */
export const formatDate = (date) => {
	if (!date) return '';

	const d = new Date(date);
	if (isNaN(d.getTime())) return '';

	const day = String(d.getDate()).padStart(2, '0');
	const month = String(d.getMonth() + 1).padStart(2, '0');
	const year = d.getFullYear();

	return `${day}/${month}/${year}`;
};